(ns teamoesterreich.user-mode.profile.profile-documents
  (:require
    [clojure.string :as str]
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.access-time :refer [access-time]]
    [reagent-material-ui.icons.check :refer [check]]
    [reagent-material-ui.icons.cloud-download :refer [cloud-download]]
    [reagent-material-ui.icons.cloud-upload :refer [cloud-upload]]
    [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
    [reagent-material-ui.icons.insert-drive-file :refer [insert-drive-file]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]] ;;(h/event-value e)
    [reagent-material-ui.icons.picture-as-pdf :refer [picture-as-pdf]]
    [reagent-material-ui.icons.warning :refer [warning]]
    [reagent.core :as r]
    [teamoesterreich.firebase.storage-provider :as storage-provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.ui-helper.are-you-sure-modal :as ays-modal]
    [teamoesterreich.user-mode.ui-helper.preview-modal :as preview-modal]


    [teamoesterreich.util.helper :as h]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.util.log :as log]))


(def TYPES
  {"identification"             "Ausweis"
   "picture"                    "Profilbild"
   "lebensretter-qualification" "Lebensretter Qualifikation"
   "other"                      "Sonstiges"
   })

(defn select-type [!state]
  (fn []
    [mui/select
     {:fullWidth true
      :value     (:type @!state)
      :onChange  (fn [e]
                   (log/out "Change type  -> " (h/event-value e))
                   (swap! !state assoc-in [:type] (h/event-value e)))
      }
     [mui/menu-item {:key "identification" :value "identification"} "Ausweis"]
     [mui/menu-item {:key "picture" :value "picture"} "Profilbild"]
     [mui/menu-item {:key "lebensretter-qualification" :value "lebensretter-qualification"} "Lebensretter Qualifikation"]
     [mui/menu-item {:key "other" :value "other"} "Sonstiges"]
     ]))




(defn upload-part [!state !userId]
  (fn []
    (log/out "upload-part  -> " @!state @!userId)
    [:div
     [:input {:accept "image/" :id "photoUpload" :type "file"
              :style  {:display "none"}}]
     [:label {:for "photoUpload"}



      [mui/button {
                   :variant   "outlined"
                   :startIcon (r/as-element [cloud-upload])
                   :component "label"
                   :style     {:width "200px"}
                   }
       "Neues Dokument" (when (:progress @!state) (str " ... " (:progress @!state) "%"))
       [:input {:accept   "image/" :id "photoUpload"
                :type     "file"
                :hidden   true
                :onChange (fn [e]
                            (let [file (.item e.target.files 0)]
                              ;(log/out "################################################  upload fired..." @!userId " <" (:type @!state) "> file" file)
                              (storage-provider/upload-user-file file @!userId (:type @!state)
                                                                 (fn [path]
                                                                   (log/out "<<<<<<<<<<<<  upload callback fired " path)
                                                                   (a/add-user-document {:deleted false :locked false :path path :name (.-name file) :uploaded (js/Date.) :type (:type @!state)})
                                                                   (swap! !state assoc :progress nil))
                                                                 (fn [p] (swap! !state assoc :progress p)))
                              ))
                }]]

      ]
     ]
    )

  )

(defn specific-upload-button [type !state !userId & [name]]
  (fn []
    (log/out "upload-part  -> " @!state @!userId)
    [:div {:className "specific-upload-button"}
     [:input {:accept "image/" :id "photoUpload" :type "file"
              :style  {:display "none"}}]
     [:label {:for "photoUpload"}



      [mui/button {
                   :variant   "outlined"
                   :startIcon (r/as-element [cloud-upload])
                   :component "label"
                   :style     {:width "200px"}
                   }
       (or name "Hochladen") (when (:progress @!state) (str " ... " (:progress @!state) "%"))
       [:input {:accept   "image/" :id "photoUpload"
                :type     "file"
                :hidden   true
                :onChange (fn [e]
                            (let [file (.item e.target.files 0)]
                              ;(log/out "################################################  upload fired..." @!userId " <" (:type @!state) "> file" file)
                              (storage-provider/upload-user-file file @!userId type
                                                                 (fn [path]
                                                                   (log/out "<<<<<<<<<<<<  upload callback fired " path)
                                                                   (a/add-user-document {:deleted false :locked false :path path :name (.-name file) :uploaded (js/Date.) :type type})
                                                                   (swap! !state assoc :progress nil))
                                                                 (fn [p] (swap! !state assoc :progress p)))
                              ))
                }]]

      ]
     ]
    )

  )


(defn document-block [documentId {:keys [type name path uploaded locked valid-from valid-until rejected rejectMessage] :as doc}]
  (log/out "document-block instance")

  (let [!state (r/atom {:url nil :loading false :show-delete-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])
        !show-delete-modal (r/cursor !state [:show-delete-modal])
        delete-fn #(reset! !show-delete-modal true)
        drop-file-fn #(a/set-user-document documentId {:deleted true})
        ]
    (fn []
      (when (and path (not (:loading @!state)))
        ;(storage-provider/get-metadata path (fn [metadata]
        ;                                      (log/out "store callback metadata " metadata)
        ;                                      (swap! !state assoc :metadata metadata)
        ;                                      ))
        (storage-provider/get-download-url-and-type path
                                                    (fn [{:keys [url content-type]}]
                                                      (log/out "store callback previewUri " path url content-type)
                                                      (swap! !state assoc :url url :path path)
                                                      (swap! !state assoc :content-type content-type)
                                                      (swap! !state assoc :loading true)))
        )
      (log/out "document-block load")
      [mui/grid
       {:container false
        :key       (str "document-block-" documentId)
        :xs        12                                       ;extra-small: 0px
        :style     {:padding "15px 15px 0 15px"}
        }
       [preview-modal/modal (:url @!state) !enlarge]
       [ays-modal/are-you-sure-modal !show-delete-modal "Willst du wirklich dieses Dokument löschen?" "Löschen" drop-file-fn]
       [mui/card
        {:variant "outlined"}
        [mui/card-content {

                           }
         (when path
           (if (and (:content-type @!state) (:url @!state))
             (cond
               (str/starts-with? (str (get-in @!state [:content-type])) "image/")
               [:img {:src     (:url @!state)
                      :onClick #(swap! !state assoc :enlarge (not (:enlarge @!state)))
                      :style   {:position "relative" :float "right" :maxHeight "150px"} :alt "Ansicht"}]

               (= (get-in @!state [:content-type]) "application/pdf")
               [:div {:style {:position "relative" :float "right"}}
                [picture-as-pdf {:fontSize "large"}]]

               :else
               [:div {:style {:position "relative" :float "right"}}
                [insert-drive-file {:fontSize "large"}]])
             [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
             ))
         [:div {:style {:width "calc(100% - 202px)"}}
          [mui/typography {:variant "body1" :gutterBottom true :style {}} (or (get TYPES type) (str "?" type))]
          [mui/typography {:variant "h6"} (or name path)]
          [:br]
          [mui/typography {:variant "body1" :gutterBottom true}
           (if uploaded (str "hochgeladen am: "
                             (.toLocaleDateString (js/Date. (* 1000 ^js (.-seconds uploaded))) "de-AT") " " (.toLocaleTimeString (js/Date. (* 1000 ^js (.-seconds uploaded))) "de-AT")
                             )
                        "Alter Server !!")]
          [:br]
          [mui/typography {:variant "body1" :gutterBottom true}
           (cond

             rejected [:div {:style {:color "darkred"}} [warning {:size "small"}] (str " Abgelehnt: " rejectMessage)]

             valid-until (str "gültig bis" (.toLocaleDateString (js/Date. (* 1000 ^js (.-seconds valid-until))) "de-AT"))

             :else ""                                       ;(str "--" doc)
             )
           ]
          ]

         ]
        [mui/card-actions
         (when (:url @!state)
           [mui/button {:size    "small" :color "secondary"
                        :style   {:float "right"}
                        :endIcon (r/as-element [cloud-download])
                        :onClick #(js/window.open (:url @!state))
                        } "Download"])
         (when-not locked
           [mui/button {:size    "small" :color "secondary"
                        :endIcon (r/as-element [delete-outline])
                        :onClick delete-fn
                        } "Löschen"])
         ]

        ]]
      )))


(defn document-view [!state file-name]
  (log/debug "document-view " file-name)
  (if (re-matches #"(?i).*(txt|pdf|doc|docx)$" file-name)
    [:img {:src       "/custom/img/file.png"
           :onClick   #(swap! !state assoc :enlarge (not (:enlarge @!state)))
           :className "helping-form-img"
           :alt       "Datei"}]
    [:img {:src       (:url @!state)
           :className "helping-form-img"
           :alt       "Ansicht"}]
    ))


(defn status-eh [!state !userId !actual-user !user-documents]

  (let [!state (r/atom {:url nil :loading false :show-delete-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])]
    (fn []

      (let [prop-doc (first (reverse (sort :uploaded (filter (fn [d]
                                                               (and (not (:deleted d))
                                                                    (some #{(:type d)} ["firstAid-certificate"
                                                                                        "other-certificate"
                                                                                        "professionId"
                                                                                        "lebensretter-qualification"
                                                                                        "other"])
                                                                    ))
                                                             (mapv second @!user-documents)))))
            valid-doc (first (reverse (sort :uploaded (filter (fn [d]
                                                                ;(log/out " ################  filter-eh  " (:valid d) (:isTraining d) (> (* 1000 (.-seconds (:valid-until d)) (js/Date.now))))
                                                                (and (> (* 1000 (.-seconds ^js (:validTo d)) (js/Date.now)))
                                                                     (not (:rejected d))
                                                                     (not (:deleted d))
                                                                     (:isTraining d)
                                                                     ))
                                                              (mapv second @!user-documents)))))
            doc (or valid-doc prop-doc)

            ]
        ;(log/out " ################  status-eh  " valid-doc prop-doc)
        (if doc
          (do
            (when (and (:path doc) (not (:loading @!state)))
              (storage-provider/get-download-url (:path doc)
                                                 (fn [dwn-url]
                                                   (log/out "store callback previewUri " (:path doc) dwn-url)
                                                   (swap! !state assoc :url dwn-url :path (:path doc))
                                                   (swap! !state assoc :loading true)
                                                   ))
              )

            (if valid-doc
              [:div {:class "helping-form-check-line" :style {:minHeight "110px"}}
               (log/debug "valid-doc " valid-doc)
               [preview-modal/modal (:url @!state) !enlarge]
               [:div {:class "check-line-icon"}
                [check]]
               [:div {:class "check-line-text"}
                "Qualifikationsnachweis / EH - Zeugnis hochgeladen und geprüft"
                [:br] (:name doc)
                ;(log/out " ################  valid-until " doc)
                [:br] [:span {:style {:color "darkgreen"}} "Danke, dein Nachweis ist gültig bis: " [:b (.toLocaleDateString (js/Date. (* 1000 ^js (.-seconds ^js (:validTo doc)))))]]
                ]
               (when (:path doc)
                 (if (:url @!state)
                   (document-view !state (:name doc))
                   [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                   ))
               ]
              ;else
              [:div {:class "helping-form-check-line" :style {:minHeight "100px"}}
               [preview-modal/modal (:url @!state) !enlarge]
               [:div {:class "check-line-icon"}
                (if (:rejected prop-doc) [warning {:style {:color "darkred"}}] [access-time])]
               (if (:rejected prop-doc)
                 ;rejected
                 [:div {:class "check-line-text"}
                  "Qualifikationsnachweis abgelehnt: "
                  [:br] (:name doc)
                  [:br]
                  [:span {:style {:color "darkred"}} (:rejectMessage prop-doc)]
                  [(specific-upload-button "firstAid-certificate" !state !userId "hochladen")]]

                 [:div {:class "check-line-text"}
                  "Qualifikationsnachweis hochgeladen bitte warte auf die Validierung."
                  [:br] (:name doc)
                  [:br]
                  [:span {:style {:color "#ac740d"}} "Bitte um Geduld, die Bestätigung ist unsererseits noch ausständig."]])
               (when (:path doc)
                 (if (:url @!state)
                   (document-view !state (:name doc))
                   [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                   ))

               ]))
          ;else
          (when (:request-lebensretter @!actual-user)
            [:div {:class "helping-form-check-line"}
             [:div {:class "check-line-icon"}
              [warning {:style {:color "darkred"}}]]
             [:div {:class "check-line-text"}
              "Lebensretter Qualifikation Nachweis hochladen "
              [:br]
              [:span {:style {:color "#ac740d"}} "(du kannst regional größere Einsatzradien und/oder höhere Priorisierung bekommen)"]]
             [(specific-upload-button "firstAid-certificate" !state !userId)]
             ])
          )))))




(defn status-identity [!state !userId !actual-user !user-documents]
  (let [!state (r/atom {:url nil :loading false :show-delete-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])]
    (fn []
      (let [prob-doc (first (reverse (sort :uploaded (filter (fn [d]
                                                               (and (not (:deleted d))
                                                                    (some #{(:type d)} ["identification"])
                                                                    ))
                                                             (mapv second @!user-documents)))))
            valid-doc (first (reverse (sort :uploaded (filter (fn [d]
                                                                (and (:isIdentity d)
                                                                     (not (:rejected d))
                                                                     (not (:deleted d))))
                                                              (mapv second @!user-documents)))))
            doc (or valid-doc prob-doc)
            ]
        (if doc
          (do
            (when (and (:path doc) (not (:loading @!state)))
              (storage-provider/get-download-url (:path doc)
                                                 (fn [dwn-url]
                                                   (log/out "store callback previewUri " (:path doc) dwn-url)
                                                   (swap! !state assoc :url dwn-url :path (:path doc))
                                                   (swap! !state assoc :loading true)
                                                   ))
              )
            (if (:isIdentity doc)
              [:div {:class "helping-form-check-line" :style {:minHeight "110px"}}
               (log/debug ":isIdentity " doc)
               [preview-modal/modal (:url @!state) !enlarge]
               [:div {:class "check-line-icon"}
                [check {:style {:color "darkgreen"}}]]
               [:div {:class "check-line-text"}
                "Ausweis hochgeladen (Identität bestätigt)"
                [:br] (:name doc)
                [:br]
                [:span {:style {:color "darkgreen"}} "Danke, deine Identität konnten wir somit bestätigen."]]
               (when (:path doc)
                 (if (:url @!state)
                   (document-view !state (:name doc))
                   [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                   ))
               ]
              ;else
              [:div {:class "helping-form-check-line" :style {:minHeight "110px"}}
               (log/debug ":maybeIdentity " doc)
               [preview-modal/modal (:url @!state) !enlarge]
               [:div {:class "check-line-icon"}
                (if (:rejected prob-doc) [warning {:style {:color "darkred"}}] [access-time])]
               (if (:rejected prob-doc)
                 ;rejected
                 [:div {:class "check-line-text"}
                  "Ausweisdokument abgelehnt: "
                  [:br] (:name doc)
                  [:br]
                  [:span {:style {:color "darkred"}} (:rejectMessage prob-doc)]
                  [(specific-upload-button "identification" !state !userId)]]
                 ;waiting
                 [:div {:class "check-line-text"}
                  "Ausweis hochgeladen (Identität noch nicht bestätigt)"
                  [:br] (:name doc)
                  [:br]
                  [:span {:style {:color "#ac740d"}} "Bitte um Geduld dein Ausweis wird von uns innerhalb von ein paar Tagen bestätigt."]])
               (when (:path doc)
                 (if (:url @!state)
                   (document-view !state (:name doc))
                   [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                   ))
               ]))
          (when
            (or
              (:request-catastrophy @!actual-user)
              (:request-lebensretter @!actual-user)
              (:request-nokat @!actual-user))
            [:div {:class "helping-form-check-line"}
             [:div {:class "check-line-icon"}
              [warning {:style {:color "darkred"}}]]
             [:div {:class "check-line-text"}
              "Ausweis hochladen (erforderlich für "
              (when (:request-catastrophy @!actual-user) "Helfen im Katastrophenfall [optional],")
              (when (:request-nokat @!actual-user) "Helfen ohne Katastrophenfall [optional],")
              (when (:request-lebensretter @!actual-user) "Lebensretter,")
              ")"
              [:br]
              [:span {:style {:color "#ac740d"}} "Bitte mache ein Foto von deinem Führerschein oder Pass und lade es hier hoch."]]
             [(specific-upload-button "identification" !state !userId)]
             ])
          )))))


(defn get-it [& [{:keys [go-back] :or {go-back #(a/set-page-back)}}]]
  (let [!userId (r/cursor store/app-state [:firebase-uid])
        !actual-user (r/cursor store/app-state [:actual-user])
        !user-documents (r/cursor store/app-state [:user-documents])
        !state (r/atom {:process false :type "identification"})
        is-lr (:request-lebensretter @!actual-user)]
    (fn []
      (log/out "rerender documents !actual-user:" (clj->js @!actual-user))
      (log/out "rerender documents !user-documents:" (clj->js @!user-documents))
      (a/set-bottom-action-fn go-back)
      [mui/grid
       {:container  true
        :direction  "column"
        :justify    "center"
        :alignItems "center"
        :spacing    4
        :style      {:marginTop "25px"}
        }
       [mui/grid
        {:container false
         :md        6                                       ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         }
        [mui/paper {:class ""
                    :style {:textAlign "left" :padding "25px"
                            }}
         [mui/grid
          {:container  true
           :direction  "row"
           :justify    "space-between"
           :alignItems "flex-start"
           :spacing    1
           }
          [mui/grid
           {:container false
            :item      true
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:h1
            "Dokumente Status"]
           ]



          [mui/grid
           {:container false
            :item      true
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [(status-identity !state !userId !actual-user !user-documents)]
           ]

          (when is-lr
            [mui/grid
             {:container false
              :item      true
              :xs        12                                 ;extra-small: 0px
              :style     {:padding "15px"}
              }

             [(status-eh !state !userId !actual-user !user-documents)]
             ])






          [mui/grid
           {:container false
            :item      true
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }


           ;[:span {:style {:color "brown"}} "Funktioniert erst wenn das Feature im Admin Teil soweit ist!"]
           ]


          [mui/grid
           {:container false
            :item      true
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:h1
            "Meine Dokumente"]
           [:span "Hier kannst du Deine Dokumente hochladen"]
           [:br]

           ]

          [mui/grid
           {:container false
            :item      true
            :xs        6                                    ;extra-small: 0px
            :style     {:padding "15px"}
            }

           [(select-type !state)]]

          [mui/grid
           {:container false
            :item      true
            :xs        6                                    ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [(upload-part !state !userId)]]

          (for [[documentId user-document] @!user-documents]
            (when-not (true? (:deleted user-document))
              (log/out "document row  -> " user-document)
              ^{:key (str "document-" documentId)} [document-block documentId user-document]
              ))

          [mui/grid
           {:container false
            :md        5                                    ;medium: 960px
            :xs        5                                    ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [mui/button
            {:variant   "contained"
             :style     {:margin "10px 0 10px 10px" :width "200px"}
             :onClick   go-back
             :startIcon (r/as-element [keyboard-arrow-left])
             }
            "Zurück"]

           ]

          ]]]]
      )))